import { render, staticRenderFns } from "./toInsurePage.vue?vue&type=template&id=0cf80a00&"
import script from "./toInsurePage.vue?vue&type=script&lang=js&"
export * from "./toInsurePage.vue?vue&type=script&lang=js&"
import style0 from "./toInsurePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cf80a00')) {
      api.createRecord('0cf80a00', component.options)
    } else {
      api.reload('0cf80a00', component.options)
    }
    module.hot.accept("./toInsurePage.vue?vue&type=template&id=0cf80a00&", function () {
      api.rerender('0cf80a00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Insurance/components/toInsurePage.vue"
export default component.exports